// import * as Sentry from "@sentry/nuxt";

export default defineNuxtRouteMiddleware((to, from) => {
  const { $site } = useNuxtApp()

  if (!($site && $site.location)) {
    return navigateTo('https://book.app/not-found', { external: true })
  }

  // Sentry.setTag("location_id", $site.location.id);
  // Sentry.setTag("location_slug", $site.domain.slug);
})
